export default "__VITE_PUBLIC_ASSET__2ae6d724__"